import React, { useEffect, useState } from 'react'
import { useAuthContext } from '@/context/auth/useAuthContext';
import { deleteFollowerData } from '@/api/followers';
import Modal from '@/components/ui/modal';
import ChatConfirmationModal from '@/components/messages-comps/chat-room-by-id/chat-confirmation-modal';
import { enqueueSnackbar } from 'notistack';
import ContentUser from '../content-user';
import { getAllUserFollowing } from '@/api/posts';
import NoNotesAvailable from '@/components/create-notes-manager-comps/no-notes-available';

const ContentUserList = ({ postUsers }) => {

    const { user } = useAuthContext();

    const [users, setUsers] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedContentUser, setSelectedContentUser] = useState(null);
    const [currentUserFollowing, setCurrentUserFollowing] = useState([]);
    const [effectTrigger, setEffectTrigger] = useState(0);

    const openModal = (postUser) => {
        setIsOpen(true);
        setSelectedContentUser(postUser);
    }

    const closeModal = () => {
        setIsOpen(false);
        setSelectedContentUser(null);
    }

    const fetchAllUserFollowing = async (userId) => {
        if (!userId) return;
        try {
            const response = await getAllUserFollowing(userId);
            if (Array.isArray(response)) {
                setCurrentUserFollowing(response);
            }
        } catch (error) {
            enqueueSnackbar(
                error?.response?.data?.message ||
                error?.message ||
                apiT("error message"),
                {
                    variant: "error",
                }
            );
        }
    };

    const handleUnfollowUser = async (postUser) => {
        try {
            console.log(postUser);
            const id = currentUserFollowing.find(
                (_f) => _f?.userId === postUser.id
            )?.id;

            if (!id) return;

            await deleteFollowerData(id);

            setUsers((prev) => {
                const updatedUsers = [...prev];
                const userToBeFollowed = updatedUsers.find((user) => user.id == postUser.id);
                if (userToBeFollowed?.followers) {
                    userToBeFollowed.followers = userToBeFollowed.followers.filter((_f) => _f.id != id);
                    userToBeFollowed._count.followers = userToBeFollowed.followers.length;
                }
                return updatedUsers;
            })

            setIsOpen(false);
            setSelectedContentUser(null);

        } catch (error) {
            enqueueSnackbar(
                error?.response?.data?.message || error?.message || "Error",
                {
                    variant: "error",
                }
            );
        } finally {
            setEffectTrigger(effectTrigger + 1);
        }
    }

    useEffect(() => {
        if (postUsers) {
            setUsers(Object.values(postUsers));
        }
    }, [postUsers])

    useEffect(() => {
        if (user?.userId) {
            fetchAllUserFollowing(user.userId);
        }
    }, [effectTrigger, user]);

    if (!postUsers || Object.keys(postUsers).length === 0) return <NoNotesAvailable text="No_user" />;

    return (
        <>
            {
                users?.map((postUser) => {
                    return (
                        <ContentUser
                            key={postUser?.id}
                            postUser={postUser}
                            setUsers={setUsers}
                            onUnfollow={() => openModal(postUser)}
                            currentUserFollowing={currentUserFollowing}
                            setEffectTrigger={setEffectTrigger}
                        />
                    )
                })
            }

            <Modal
                isOpen={isOpen}
                onClose={closeModal}
                title={"Are you sure you want to unfollow this user"}
            >

                <ChatConfirmationModal
                    onOkText="Unfollow"
                    onCancel={closeModal}
                    onOk={() => handleUnfollowUser(selectedContentUser)}
                />

            </Modal>
        </>
    )
}

export default ContentUserList